import { Playlist, PlaylistTag, SearchPlaylistsDTO } from '~/@types/tsl-types';

import { emptySplitApi } from './emptySplitApi';

export const playlistApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlaylists: builder.query<PlaylistTag[], SearchPlaylistsDTO>({
      query: (params) => ({
        method: 'GET',
        url: 'tags/playlists',
        params,
      }),
      forceRefetch() {
        return true;
      },
    }),
    getPlaylistById: builder.query<Playlist, string>({
      query: (playlistId) => ({
        method: 'GET',
        url: `playlists/bam/${playlistId}?userContext=BAM`,
      }),
      forceRefetch() {
        return true;
      },
    }),
  }),
});

export const { useGetPlaylistsQuery, useGetPlaylistByIdQuery } = playlistApi;
